/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_radius = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotor radius`)
};

const es_gf_radius = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radio del rotor`)
};

const de_gf_radius = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotorradius`)
};

const nl_gf_radius = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotorstraal`)
};

const fr_gf_radius = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rayon du rotor`)
};

const it_gf_radius = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raggio del rotore`)
};

const pt_br2_gf_radius = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raio do rotor`)
};

const pt_gf_radius = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raio do rotor`)
};

const ja_gf_radius = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ローター半径`)
};

const zh_gf_radius = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转子半径`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_radius = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_radius(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_radius", locale)
	if (locale === "en") return en_gf_radius(inputs)
	if (locale === "es") return es_gf_radius(inputs)
	if (locale === "de") return de_gf_radius(inputs)
	if (locale === "nl") return nl_gf_radius(inputs)
	if (locale === "fr") return fr_gf_radius(inputs)
	if (locale === "it") return it_gf_radius(inputs)
	if (locale === "pt-BR") return pt_br2_gf_radius(inputs)
	if (locale === "pt") return pt_gf_radius(inputs)
	if (locale === "ja") return ja_gf_radius(inputs)
	return zh_gf_radius(inputs)
};